import React from "react";
import { scaledScoreProps } from "./dataTypes";

const ScaledScoreWidget = ({ scaledScores }: scaledScoreProps) => {
  return (
    <div
      className="flex flex-col justify-between items-center w-full h-[400px] p-3 pb-[61px] border border-satPrepGrey rounded-[18px] bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive">
      <h2 className="text-3xl font-gully font-medium text-satPrepDarkAccent text-center">
        Section score overview
      </h2>

      <ScoreBar label="Reading & Writing" score={scaledScores?.ReadingAndWriting} />
      <ScoreBar label="Math" score={scaledScores?.Mathematics} />
    </div>
  );
};

export default ScaledScoreWidget;

const ScoreBar = ({ label, score }: { label: string; score: number }) => {
  const totalFilledBars = (score  / 100);
  const fullyFilledBars = Math.floor(score / 100);
  const partialFilledBars  = totalFilledBars - fullyFilledBars;
  const emptyBars = 8 - fullyFilledBars - (partialFilledBars > 0 ? 1 : 0); 

  return (
    <div className="flex flex-col items-center w-full gap-4">
      <span className="text-[26px] font-semibold text-satPrepXDarkAccent text-center font-gully">
        {label}
      </span>
      <div className="flex gap-8 items-center">

        <div className="flex items-center gap-4">

          {Array.from({ length: fullyFilledBars }).map((_, i) => (<div key={i} className="w-[52px] h-[52px] bg-satPrepAccent rounded-md"></div>))}

          {partialFilledBars > 0 && (<div className="w-[52px] h-[52px] bg-satPrepLightGrey relative rounded-md" style={{background: `linear-gradient(to right, #47ACFF ${partialFilledBars * 100}%, #EFEFF1 ${partialFilledBars * 100}%)`}}></div>)}

          {Array.from({ length: emptyBars }).map((_, i) => (<div key={i} className="w-[52px] h-[52px] bg-satPrepLightGrey rounded-md"></div>))}

        </div>

        <div className="w-1 h-[52px] bg-satPrepBlack rounded"></div>

        <p className="text-lg font-medium text-satPrepBlack text-center font-gully ">
          {score}/800
        </p>

      </div>
    </div>
  );
};
